import { createInstance } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { merge } from 'lodash-es';
import { initReactI18next } from 'react-i18next';

import { resources as udacityApplicationResources } from '@udacity/application/i18n';
import { resources as udacityCertificateResources } from '@udacity/udacity-certificate/i18n';
import { resources as udacityHeaderResources } from '@udacity/udacity-header-v2/i18n';

import enUS from './locales/en-US.json';
import { languages } from './languages';

type LngResource = { translation?: Record<string, unknown> };

const enUSCert = (udacityCertificateResources as Record<string, LngResource>)['en-US']?.translation;
const enUSHeader = (udacityHeaderResources as Record<string, LngResource>)['en-US']?.translation;
const enUSApp = (udacityApplicationResources as Record<string, LngResource>)['en-US']?.translation;

const initialResources = {
  [languages.enUS.id]: {
    translation: merge({}, enUS, enUSCert, enUSHeader, enUSApp),
  },
};

const i18n = createInstance({
  resources: initialResources,
  fallbackLng: languages.enUS.id,
  debug: false,
  interpolation: { escapeValue: false },
  react: { useSuspense: true },
  returnEmptyString: false,
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['navigator', 'cookie', 'localStorage'],
    },
  });

export { i18n };
